import { createAppStore } from '@store/createAppStore';
import { AddressBookState } from '@store/customers/customerDetails/addressBookTab';

const [addressBookStore, setAddressBookStore] =
  createAppStore<AddressBookState>(
    {
      isLoading: false,
      isError: false,
      errorMessage: '',
      items: [],
      addOrEditErrorMessage: '',
      importAddressErrorMessage: '',
      selectedAddress: null,
    },
    'addressBookStore',
  );

export { addressBookStore, setAddressBookStore };
